// extracted by mini-css-extract-plugin
export default {"trigger":"tooltip_trigger__oNDj3","button":"tooltip_button__Zc7iO","bubble":"tooltip_bubble__2vmYS"};